import * as ChamadaService from '@/services/chamada.service';

export default {
    namespaced: true,
    state: () => ({
        list: {
            initialized: false,
            values: []
        }
    }),
    actions: {
        async load({ commit, state }) {
            if (state.list.initialized) {
                return Promise.resolve(state.list);
            }
            try {
                const res = await ChamadaService.getAll();
                commit('LOAD_CHAMADAS', res.data);
                return await Promise.resolve(res.data);
            } catch (e) {
                return await Promise.reject();
            }
        },
        async create({ commit }, chamada) {
            const res = await ChamadaService.create(chamada);
            commit('ADD_CHAMADA', res.data);
            return await Promise.resolve(res.data);
        },
    },
    mutations: {
        LOAD_CHAMADAS(state, data) {
            state['list']['initialized'] = true;
            state['list']['values'] = data;
        },
        ADD_CHAMADA(state, chamada) {
            state['list']['values'].push(chamada);
        },
    },
    getters: {
        list: state => {
            return state.list.values;
        },
        chamadasByPS: (state) => (id) => {
            return state.list.values.filter(chamada => chamada.processoSeletivo.id === id)
        }
    }
}